<template>
  <div class="app-container">
    <div class="top_title">
      <div class="title_left">
        <img
          src="@/assets/personalCenter/logo.png"
          style="width:60px;height:60px;border-radius: 4px"
        />
        <p>同正<br />
          <span>统一身份认证</span>
        </p>
      </div>
      <div class="topBar">
        <router-link :to="{name: 'workHall'}" tag="div">
          <i class="el-icon-s-home"></i> 办事大厅
        </router-link>
        <router-link :to="{name:'personalCenter'}" tag="div">
          <i class="el-icon-s-custom"></i> 个人大厅
        </router-link>
        <router-link :to="{name:'operatoRegister'}" tag="div">
          <i class="el-icon-s-custom"></i> 运营商注册
        </router-link>
        <router-link :to="{name:'application'}" tag="div">
          <i class="el-icon-menu"></i> 应用服务大厅
        </router-link>
      </div>
      <div class="title_right">
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <div class="flex">
              <img  :src="userInfo.url ? userInfo.url : avatarUrl" alt="" style="width:36px;height:36px;border-radius: 50%;"/>
              <!-- <el-image
                :src="userInfo.url ? userInfo.url : avatarUrl"
                style="width:36px;height:36px;border-radius: 50%;"
              /> -->
              <span>{{userInfo.realName}}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </div>
          </span>
          <el-dropdown-menu slot="dropdown">
            <!-- <el-dropdown-item command="b">
              <i class="el-icon-setting" />后台管理
            </el-dropdown-item> -->
            <el-dropdown-item command="a">
              <i class="el-icon-switch-button" />退出登录
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import {getUrlTitle} from "@/utils/auth";
export default {
  components: {},
  data() {
    return {
      avatarUrl: require('@/assets/personalCenter/avatar.png'),
      title:'',
    }
  },
  created() {
    this.title = getUrlTitle()

  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  methods: {
    // 退出系统
    loginOut() {
      this.$confirm('是否确认退出？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          sessionStorage.clear()
          this.$store.dispatch('user/logout').then(() => {
            this.$router.push({
              name: 'login'
            })
          })
        })
        .catch(() => {})
    },
    // 点击下拉菜单
    handleCommand(command) {
      if (command == 'a') {
        this.loginOut()
      } else if (command == 'b') {
        this.$router.push({name:"adminRegister"})
      }
    }
  }
}
</script>

<style scoped lang='less'>
div.top_title {
  width: 100%;
  height: 80px;
  background: rgba(255, 255, 255, 1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  .title_left {
    display: flex;
    align-items: center;
    padding-left: 10px;
    p {
      padding-left: 10px;
    }
  }
  .title_right {
    display: flex;
    height: 100%;
    align-items: center;
    padding-right: 43px;
    span {
      padding: 0 10px;
      cursor: pointer;
    }
  }
}
.topBar {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #666;
  div {
    margin: 0 30px;
    cursor: pointer;
  }
}
.topBar i {
  position: relative;
}
.topBar div.router-link-active {
  color: #346bfd;
}
.topBar div.router-link-active i::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  background: #346bfd;
  bottom: -30px;
  left: 0;
}
.flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>

